import React, { useState } from 'react';
import { Button, Modal, Col, Form, Row } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { useFirebase } from '../../../contexts/FirebaseContext';

const AddTrack = ({ docLength }) => {
  const [showAddTrack, setShowAddTrack] = useState(false);
  const { addTrack } = useFirebase();

  const { register, reset, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    let track = `Track-${docLength + 1}`;
    await addTrack(track, {
      name: data.track,
    })
      .then(reset())
      .then(() => {
        toast.success(`${data.track} has been added!`, {
          duration: 2000,
          icon: '👏',
        });
      })
      .then(
        setTimeout(() => {
          window.location.reload();
        }, 2000)
      )
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          className='btn-primary ml-2 mt-2 mb-2'
          onClick={() => setShowAddTrack(true)}
        >
          Add Track
        </Button>
      </div>

      <Modal
        size='md'
        data-backdrop='static'
        data-keyboard='false'
        animation={true}
        show={showAddTrack}
        onHide={() => setShowAddTrack(!showAddTrack)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Track</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                {/* Track */}
                <Form.Label>Track</Form.Label>
                <Form.Group controlId='formAddTrack'>
                  <Form.Control
                    type='text'
                    name='track'
                    placeholder='What track?'
                    ref={register({ required: true })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button className='w-25' variant='primary' type='submit'>
                  Add
                </Button>
                <Toaster />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddTrack;
